var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "BuildABox" },
    [
      _c(
        "div",
        { staticClass: "build-wrapper" },
        [
          _c("div", { staticClass: "builder-content-wrapper" }, [
            _c(
              "div",
              {
                staticClass: "builder-experience-container no-scrollbar",
                attrs: { id: "scroll-container" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "full-view-header header-steps-wrapper flex flex-align-center flex-justify-center pd-2rem gap-1vw"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "header-steps-container m-w-100 gap-1vw w-auto bg-white rounded-button shadow-dark flex flex-align-center flex-justify-between p-l-2rem"
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass:
                              "steps body-base flex flex-align-center flex-justify-center p-r-1rem"
                          },
                          [
                            _c("span", { staticClass: "p-r-05rem" }, [
                              _vm._v(
                                "STEP " + _vm._s(_vm.currentStep) + " OF 4:"
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "dot" }, [
                              _c("span", {
                                class: 1 <= _vm.currentStep ? "selected" : ""
                              })
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "dot" }, [
                              _c("span", {
                                class: 2 <= _vm.currentStep ? "selected" : ""
                              })
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "dot" }, [
                              _c("span", {
                                class: 3 <= _vm.currentStep ? "selected" : ""
                              })
                            ]),
                            _vm._v(" "),
                            _vm._m(0)
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "steps-text body-base flex flex-align-center gap-1vw desktop"
                          },
                          [
                            _c(
                              "p",
                              { class: 1 == _vm.currentStep ? "selected" : "" },
                              [_vm._v("Pick Gifts")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "step-arrow" }, [
                              _vm._v(" > ")
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { class: 2 == _vm.currentStep ? "selected" : "" },
                              [_vm._v("Select Your Box")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "step-arrow" }, [
                              _vm._v(" > ")
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { class: 3 == _vm.currentStep ? "selected" : "" },
                              [_vm._v("Write Your Card")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "step-arrow" }, [
                              _vm._v(" > ")
                            ]),
                            _vm._v(" "),
                            _c("p", [_vm._v("Shipping")])
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "body-base mobile" }, [
                          _vm._v(_vm._s(_vm.stepText))
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "hb-btn primary slim p-l-unset p-r-unset",
                            attrs: { disabled: !_vm.canNext },
                            on: {
                              click: function($event) {
                                _vm.currentStep == 3
                                  ? _vm.openCart()
                                  : _vm.changePage(true)
                              }
                            }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "p-r-2rem p-l-2rem desktop" },
                              [_vm._v("Next Step >")]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "p-r-1rem p-l-1rem mobile" },
                              [_vm._v("Next >")]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "full-view-header header-actions-wrapper bg-white flex flex-align-center flex-justify-between gap-1vw p-l-2rem p-r-2rem p-t-1rem p-b-1rem",
                    attrs: { id: "header-actions" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "desktop flex flex-align-center flex-justify-between gap-1vw w-100"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "header-action-section flex-1 flex flex-align-center flex-justify-between gap-1vw"
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "body-base color-link font-bold hov-underline flex-shrink-0",
                                on: {
                                  click: function($event) {
                                    return _vm.changePage(false)
                                  }
                                }
                              },
                              [_vm._v("< Back")]
                            ),
                            _vm._v(" "),
                            _vm.currentStep != 2
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "buttons-container w-100 flex flex-align-center gap-1vw"
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "hb-btn thick wp-nowrap link slim filters flex flex-align-center flex-justify-between gap-05vw",
                                        on: {
                                          click: function($event) {
                                            return _vm.showFilters()
                                          }
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticClass:
                                            "purple h-auto hov-primary-img",
                                          attrs: {
                                            width: "15px",
                                            height: "15px",
                                            src:
                                              "https://cdn.shopify.com/s/files/1/1363/8433/files/filter_purple.svg?v=1723141690"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("img", {
                                          staticClass: "purple h-auto hov-img",
                                          attrs: {
                                            width: "15px",
                                            height: "15px",
                                            src:
                                              "https://cdn.shopify.com/s/files/1/1363/8433/files/filter_white.svg?v=1749590428"
                                          }
                                        }),
                                        _vm._v(
                                          "\n                  Filters \n                  "
                                        ),
                                        !_vm.selectedCardsOccasions.includes(
                                          "View All"
                                        )
                                          ? _c("span", [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(
                                                    _vm.selectedCardsOccasions
                                                      .length
                                                  ) +
                                                  ")"
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.currentStep == 1
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "hb-btn thick wp-nowrap link slim filters flex flex-align-center flex-justify-between gap-05vw",
                                            on: {
                                              click: function($event) {
                                                return _vm.showSort()
                                              }
                                            }
                                          },
                                          [
                                            _c("img", {
                                              staticClass:
                                                "h-auto hov-primary-img",
                                              attrs: {
                                                width: "15px",
                                                height: "10px",
                                                src:
                                                  "https://cdn.shopify.com/s/files/1/1363/8433/files/sort.svg?v=1749479130"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("img", {
                                              staticClass: "h-auto hov-img",
                                              attrs: {
                                                width: "15px",
                                                height: "10px",
                                                src:
                                                  "https://cdn.shopify.com/s/files/1/1363/8433/files/sort_white.svg?v=1749590429"
                                              }
                                            }),
                                            _vm._v(
                                              "\n                  Sort Products\n                "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "header-action-section flex-1 flex flex-align-center flex-justify-center gap-1vw"
                          },
                          [
                            _c(
                              "p",
                              { staticClass: "body-base step-text wp-nowrap" },
                              [_vm._v(_vm._s(_vm.currentCopy))]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "steps body-base flex-align-center flex-justify-center p-r-1rem flex-shrink-0"
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "p-r-05rem flex-shrink-0" },
                                  [
                                    _vm._v(
                                      "STEP " +
                                        _vm._s(_vm.currentStep) +
                                        " OF 4:"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "dot" }, [
                                  _c("span", {
                                    class:
                                      1 <= _vm.currentStep ? "selected" : ""
                                  })
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "dot" }, [
                                  _c("span", {
                                    class:
                                      2 <= _vm.currentStep ? "selected" : ""
                                  })
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "dot" }, [
                                  _c("span", {
                                    class:
                                      3 <= _vm.currentStep ? "selected" : ""
                                  })
                                ]),
                                _vm._v(" "),
                                _vm._m(1)
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "header-action-section between-sticky flex-1 flex flex-align-center flex-justify-end gap-1vw"
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "hb-btn primary p-l-unset p-r-unset sticky",
                                attrs: { disabled: !_vm.canNext },
                                on: {
                                  click: function($event) {
                                    _vm.currentStep == 3
                                      ? _vm.openCart()
                                      : _vm.changePage(true)
                                  }
                                }
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "p-r-1rem p-l-1rem desktop" },
                                  [_vm._v("Next Step >")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "p-r-1rem p-l-1rem mobile" },
                                  [_vm._v("Next >")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "VDropdown",
                              {
                                attrs: { distance: 6 },
                                scopedSlots: _vm._u([
                                  {
                                    key: "popper",
                                    fn: function() {
                                      return [
                                        _c("p", [
                                          _vm._v(
                                            "\n                    Saved!\n                  "
                                          )
                                        ])
                                      ]
                                    },
                                    proxy: true
                                  }
                                ])
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: {
                                          content:
                                            "Save your selections for 24 hours.<br/> Inventory subject to availability",
                                          html: true
                                        },
                                        expression:
                                          "{ content: 'Save your selections for 24 hours.<br/> Inventory subject to availability', html: true }"
                                      }
                                    ],
                                    staticClass:
                                      "leave-builder cursor-pointer gap-05vw body-base color-link flex flex-align-center flex-justify-center",
                                    on: { click: _vm.leaveBuilder }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "color-link font-bold" },
                                      [_vm._v(_vm._s(_vm.headerText) + " ")]
                                    ),
                                    _vm._v(" "),
                                    _c("img", {
                                      attrs: {
                                        width: "20",
                                        height: "20",
                                        src:
                                          "https://cdn.shopify.com/s/files/1/1363/8433/files/save_cart_1.svg?v=1749479131",
                                        alt: "save cart"
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "mobile flex flex-align-center flex-justify-between gap-1vw flex-column w-100"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "header-action-section flex-1 flex flex-align-center flex-justify-center gap-1vw w-100"
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "body-base color-link font-bold hov-underline flex-shrink-0 flex-1",
                                on: {
                                  click: function($event) {
                                    return _vm.changePage(false)
                                  }
                                }
                              },
                              [_vm._v("< Back")]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "body-base step-text wp-nowrap flex-2"
                              },
                              [_vm._v(_vm._s(_vm.currentMobileCopy))]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "steps body-base flex-align-center flex-justify-center p-r-1rem flex-shrink-0"
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "p-r-05rem flex-shrink-0" },
                                  [
                                    _vm._v(
                                      "STEP " +
                                        _vm._s(_vm.currentStep) +
                                        " OF 4:"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "dot" }, [
                                  _c("span", {
                                    class:
                                      1 <= _vm.currentStep ? "selected" : ""
                                  })
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "dot" }, [
                                  _c("span", {
                                    class:
                                      2 <= _vm.currentStep ? "selected" : ""
                                  })
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "dot" }, [
                                  _c("span", {
                                    class:
                                      3 <= _vm.currentStep ? "selected" : ""
                                  })
                                ]),
                                _vm._v(" "),
                                _vm._m(2)
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex-1 flex flex-align-center flex-justify-end"
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "hb-btn primary p-l-unset p-r-unset sticky",
                                    attrs: { disabled: !_vm.canNext },
                                    on: {
                                      click: function($event) {
                                        _vm.currentStep == 3
                                          ? _vm.openCart()
                                          : _vm.changePage(true)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "p-r-1rem p-l-1rem mobile"
                                      },
                                      [_vm._v("Next >")]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "VDropdown",
                                  {
                                    attrs: { distance: 6 },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "popper",
                                        fn: function() {
                                          return [
                                            _c("p", [
                                              _vm._v(
                                                "\n                    Saved!\n                  "
                                              )
                                            ])
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ])
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: {
                                              content:
                                                "Save your selections for 24 hours.<br/> Inventory subject to availability",
                                              html: true
                                            },
                                            expression:
                                              "{ content: 'Save your selections for 24 hours.<br/> Inventory subject to availability', html: true }"
                                          }
                                        ],
                                        staticClass:
                                          "leave-builder cursor-pointer gap-05vw body-base color-link flex flex-align-center flex-justify-center noStick",
                                        on: { click: _vm.leaveBuilder }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "color-link font-bold"
                                          },
                                          [_vm._v("Save ")]
                                        ),
                                        _vm._v(" "),
                                        _c("img", {
                                          attrs: {
                                            width: "20",
                                            height: "20",
                                            src:
                                              "https://cdn.shopify.com/s/files/1/1363/8433/files/save_cart_1.svg?v=1749479131",
                                            alt: "save cart"
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "header-action-section w-100 flex flex-align-center flex-justify-between"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "buttons-container w-100 flex flex-align-center gap-1vw"
                              },
                              [
                                _vm.currentStep != 2
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "hb-btn link slim filters flex flex-align-center flex-justify-between gap-05vw",
                                        on: {
                                          click: function($event) {
                                            return _vm.showFilters()
                                          }
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "purple h-auto",
                                          attrs: {
                                            width: "15px",
                                            height: "15px",
                                            src:
                                              "https://cdn.shopify.com/s/files/1/1363/8433/files/filter_purple.svg?v=1723141690"
                                          }
                                        }),
                                        _vm._v(
                                          "\n                  Filters \n                  "
                                        ),
                                        !_vm.selectedCardsOccasions.includes(
                                          "View All"
                                        )
                                          ? _c("span", [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(
                                                    _vm.selectedCardsOccasions
                                                      .length
                                                  ) +
                                                  ")"
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.currentStep == 1
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "hb-btn link slim filters flex flex-align-center flex-justify-between gap-05vw",
                                        on: {
                                          click: function($event) {
                                            return _vm.showSort()
                                          }
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "h-auto",
                                          attrs: {
                                            width: "15px",
                                            height: "10px",
                                            src:
                                              "https://cdn.shopify.com/s/files/1/1363/8433/files/sort.svg?v=1749479130"
                                          }
                                        }),
                                        _vm._v("Sort Products")
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "VDropdown",
                              {
                                attrs: { distance: 6 },
                                scopedSlots: _vm._u([
                                  {
                                    key: "popper",
                                    fn: function() {
                                      return [
                                        _c("p", [
                                          _vm._v(
                                            "\n                    Saved!\n                  "
                                          )
                                        ])
                                      ]
                                    },
                                    proxy: true
                                  }
                                ])
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: {
                                          content:
                                            "Save your selections for 24 hours.<br/> Inventory subject to availability",
                                          html: true
                                        },
                                        expression:
                                          "{ content: 'Save your selections for 24 hours.<br/> Inventory subject to availability', html: true }"
                                      }
                                    ],
                                    staticClass:
                                      "leave-builder cursor-pointer gap-05vw body-base color-link flex flex-align-center flex-justify-center sticky",
                                    on: { click: _vm.leaveBuilder }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "color-link font-bold" },
                                      [_vm._v("Save ")]
                                    ),
                                    _vm._v(" "),
                                    _c("img", {
                                      attrs: {
                                        width: "20",
                                        height: "20",
                                        src:
                                          "https://cdn.shopify.com/s/files/1/1363/8433/files/save_cart_1.svg?v=1749479131",
                                        alt: "save cart"
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.currentPage == 1
                  ? _c("Page3", {
                      ref: "giftsComponent",
                      on: {
                        leavebuilder: _vm.leaveBuilder,
                        changepage: function($event) {
                          return _vm.changePage($event)
                        },
                        gostep: function($event) {
                          return _vm.goStep($event)
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentPage == 2
                  ? _c("Page4", {
                      on: {
                        changepage: function($event) {
                          return _vm.changePage($event)
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentPage > 2
                  ? _c("Page5", {
                      ref: "cardComponent",
                      attrs: { currentPage: _vm.currentPage },
                      on: {
                        changepage: function($event) {
                          return _vm.changePage($event)
                        },
                        gotoaddonselection: _vm.goToAddonSelection,
                        opencart: function($event) {
                          return _vm.openCart()
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("SideCartNew", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.currentStep > 1,
                expression: "currentStep > 1"
              }
            ],
            ref: "outSideCart",
            attrs: {
              isSticking: _vm.isSticking,
              step: _vm.currentStep,
              fromCard: _vm.fromCard
            },
            on: {
              changepage: function($event) {
                return _vm.changePage($event)
              },
              bundle: function($event) {
                return _vm.bundle($event)
              },
              gostep: function($event) {
                return _vm.goStep($event)
              },
              cardwarning: function($event) {
                return _vm.cardWarning($event)
              }
            }
          }),
          _vm._v(" "),
          _vm.selectedAddonProducts.length > 0
            ? _c("SideCartMobile", {
                attrs: { step: _vm.currentStep },
                on: {
                  changepage: function($event) {
                    return _vm.changePage($event)
                  },
                  bundle: _vm.bundle
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.oosIsActive
        ? _c("OOSPopUp", {
            attrs: {
              oosProducts: _vm.noStockItems,
              firstStateProducts: _vm.currentStateSelectedAddons,
              fromSavedCart: _vm.fromSavedCart,
              fromCurated: _vm.fromCurated
            },
            on: {
              goback: _vm.closeOOSPopUp,
              continuesaved: _vm.continueSaved,
              continuecurated: _vm.continueCurated
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "dot" }, [_c("span")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "dot" }, [_c("span")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "dot" }, [_c("span")])
  }
]
render._withStripped = true

export { render, staticRenderFns }